import { authFetch } from "./authProvider";

const SERVICE_URL = "account-service-new/v2/organizations/:orgId";

export const getAllAccountsSummary = async (orgId) => {
  let url = SERVICE_URL.replace(":orgId", orgId) + "/accounts/summary";
  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};

export const listFleet = async (orgId) => {
  let url = SERVICE_URL.replace(":orgId", orgId) + "/accounts/0/list/fleet";
  return await authFetch("get", url, {})
    .then(function (response) {
      const data = response.data.list ?? [];
      const transformedResponse = data.map((item) => ({
        isPreSelected: item.isPreSelected,
        name: item.name,
        fleetNumber: item.vehicleNumber,
        accountId: item.accountId,
        washtypeId: item.washTypeId,
        instructions: item.instructions,
        locationNumber: item.locationNumber,
        washFrequency: item.washFrequency,
      }));
      return {
        status: response.status,
        data: { response: transformedResponse },
      };
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};
